@if (state$ | async; as state) {
	<bp-tile class="card" [title]="'staking' | translate" color="default" [padding]="false">
		@if (!state.hasError) {
			<div class="staking-widget__staked-coins" [class.mod-has-coins]="state.stakedCoins > 0" tile-actions>
				{{ "dashboard_rewards_stake_coins" | translate: ["" + state.stakedCoins] }}
			</div>
		}
		<div
			class="staking-widget__container"
			[class.mod-no-center]="
				state.totalLifetimeRewards !== 0 || (state.totalLifetimeRewards === 0 && state.stakedCoins > 0)
			">
			@if (state.init) {
				@if (state.hasError) {
					<div class="staking-widget__error"
						><span class="bpi__icon-info mod-icon"></span>
						{{ "dashboard_rewards_stake_error" | translate }}
					</div>
				} @else {
					@if (state.stakedCoins === 0 && state.totalLifetimeRewards === 0) {
						<svg-inline
							class="staking-icon"
							[src]="'/assets/images/staking/staking_rewards.svg'"
							[alt]="'logo_alt_text' | translate" />

						<!-- Specific text for UK -->
						<div class="staking-widget__container-empty">{{
							"uk_finprom_staking_banner_text" | translate: [state.highestYield | percent_symbol: false, " "]
						}}</div>
					} @else {
						<!-- Specific text for UK -->
						<div class="staking-widget__container-rewards-title">{{
							"uk_finprom_dashboard_rewards_stake_total" | translate
						}}</div>
						<div
							class="staking-widget__container-rewards-amount"
							hidePortfolioValue
							[isHideActive]="isHideValueActive$ | async"
							>{{
								state.totalLifetimeRewards
									| fiat_precision_symbol
										: { id: defaultFiat?.getId(), currencies: [defaultFiat], symbol: true }
							}}</div
						>
					}
				}
			} @else {
				<bp-content-load-indicator></bp-content-load-indicator>
			}
		</div>
		<hr class="staking-widget__divider" />
		<div class="staking-widget__button-container">
			<button class="btn btn-primary staking-widget__button" (click)="onButtonClick(state)">
				{{ state.buttonKey | translate }}
			</button>
		</div>
	</bp-tile>
}
